import "./flipper.scss";
import heads from "../../assets/heads.png";
import tails from "../../assets/tails.png";
import { getUserScore, flipACoin, canFlipACoinSync } from "../../services/score";
import { guestFlipACoin } from "../../services/guest-score";
import { useEffect, useState } from "react";
import { useAuth } from "../../services/auth";
import { userFlipCoin, userFlipResult } from "../../services/events";

const LANDING_DURATION = 2500;

const Flipper = ({ scoreDoc, setScoreDoc, guestScore, setGuestScore }) => {
    const [strikeType, setStrikeType] = useState("");
    const [isFlipping, setIsFlipping] = useState(false);
    const { user } = useAuth();

    useEffect(() => {
        if (strikeType !== "") return;
        if (scoreDoc) {
            setStrikeType(scoreDoc.currentStrikeType);
        } else if (guestScore) {
            setStrikeType(guestScore.currentStrikeType || "heads");
        }
    }, [scoreDoc, guestScore]);

    const onClickFlipACoin = async () => {
        if (isFlipping) return;

        // ── Guest mode: local flip, no Firebase ──
        if (!user) {
            setIsFlipping(true);
            setStrikeType("spinning");
            userFlipCoin();

            // Small delay so the spin is visible before landing
            await new Promise((r) => setTimeout(r, 600));

            const result = guestFlipACoin();
            const newType = result.data.currentStrikeType;
            const prevType = guestScore?.currentStrikeType || "heads";

            userFlipResult(newType, result.data.currentScore);

            if (newType === "heads") {
                setStrikeType(prevType === "heads" ? "animation-heads-heads" : "animation-tails-heads");
            } else {
                setStrikeType(prevType === "tails" ? "animation-tails-tails" : "animation-heads-tails");
            }

            setTimeout(() => {
                setGuestScore(result.score);
                setIsFlipping(false);
            }, LANDING_DURATION);
            return;
        }

        // ── Logged-in mode: Firebase ──
        if (!scoreDoc) return;
        if (!canFlipACoinSync(scoreDoc)) return;

        setIsFlipping(true);
        setStrikeType("spinning");
        userFlipCoin();

        const newScore = await flipACoin();

        const newType = newScore?.data?.currentStrikeType;
        const newStreak = newScore?.data?.currentScore;
        const prevType = scoreDoc.currentStrikeType;

        userFlipResult(newType, newStreak);

        if (newType === "heads") {
            setStrikeType(prevType === "heads" ? "animation-heads-heads" : "animation-tails-heads");
        } else if (newType === "tails") {
            setStrikeType(prevType === "tails" ? "animation-tails-tails" : "animation-heads-tails");
        }

        setTimeout(() => {
            getUserScore(user).then((score) => setScoreDoc(score));
            setIsFlipping(false);
        }, LANDING_DURATION);
    };

    return (
        <div id="flipper">
            <div
                id="coin"
                className={`${strikeType}${isFlipping ? "" : " idle"}`}
                onClick={onClickFlipACoin}
            >
                <img src={heads} alt="Heads" className="side-a" />
                <img src={tails} alt="Tails" className="side-b" />
            </div>
        </div>
    );
};

export default Flipper;
